module.exports = __webpack_public_path__ + "Journal Regular.3832c6c49bfcaa5a0708.woff";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/Journal Regular.woff
// module id = ../../../../../src/fonts/Journal Regular.woff
// module chunks = styles